import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

// const apiEndpoint = API_BASE_URL_ENV() + "/website/resale/resales";
const apiEndpoint = API_BASE_URL_ENV() + "/website/resale/resales";
const apiCheckPoint = API_BASE_URL_ENV() + "/website/resale/buy-now"
//const apiCashOnMeeting= API_BASE_URL_ENV() + 
const Cilapi = API_BASE_URL_ENV() + "/website/resale/send-cil" 
 export default class extends BaseService {
    constructor() {
        super(apiEndpoint); 
    }

    checkResale = (data) => {
        return http.post(apiCheckPoint,data)
    }

    buyCashOnMeeting = (id) => {
        const url = API_BASE_URL_ENV()+ `/crm/cash-on-meeting/${id}`
        return http.get(url);
    }
    buyBankTransfer = (data) => {
        const url = API_BASE_URL_ENV()+ `/website/user/upload-receipt`
        return http.post(url, data);
    }

    sendCil=(data)=>{
        return http.post(Cilapi, data);
    }

    sendComplain = () =>{
        return http.post(API_BASE_URL_ENV()+ '/website/user/complain')
    }

    getComplainStatus = () =>{
        return http.get(API_BASE_URL_ENV()+ '/website/user/lead-status')
    }
    
}
